import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken, EmulatedProductData } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_ADVANCEDSEARCH = false


/*
 * Advanced Search Actions
 * 
 */

export function fetchAdvancedSearchList(filter) {
    let cmd = 'FETCH_ADVANCEDSEARCH_LIST'

    if (EMULATION_ALL || EMULATION_MODE_ADVANCEDSEARCH)
        //TODO - needs to be fixed
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        if (filter) {
            execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
                dispatch(
                    {
                        type: cmd,
                        payload: {
                            data: {
                                page: filter && filter.pageIndex ? filter.pageIndex : 1
                            }
                        }
                    }
                )

                axios.post(buildRequestUrl('advancedsearch'), filter ? JSON.stringify(filter) : {}, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                    .then((resp) => {
                        dispatch(
                            {
                                type: cmd + '_FULFILLED',
                                payload: resp
                            }
                        )
                    })
                    .catch((err) => {
                        dispatch(
                            {
                                type: cmd + '_REJECTED',
                                payload: err
                            }
                        )
                    })
            })
        }
        else {
            this.props.dispatch(
                {
                    type: cmd + '_CLEAR'
                }
            )
        }
    }
}

export function fetchAdvancedSearchError(dispatch) {
    dispatch(
        {
            type: 'FETCH_ADVANCEDSEARCH_ERROR',
        }
    )
}